Wee.fn.make('navigation', {
	init: function() {
		var priv = this.$private;

		priv.initScreen();
		priv.initEvents();
	}
}, {
	_construct: function() {
		this.$mobileMenu = $('ref:mobileMenu'),
		this.$desktopMenu = $('ref:desktopMenu'),
		this.$header = $('ref:header');
		this.$footer = $('ref:footer');
	},

	/**
	 * Init screen map
	 *
	 * @private
	 */
	initScreen: function() {
		var scope = this;

		$.screen.map([
			{
				max: 3,
				callback: function() {
					scope.initMobileNav();
					scope.closeMobileNav();
				}
			},
			{
				min: 4,
				callback: function() {
					scope.closeMobileNav();
					scope.initDesktopNav();
				}
			}
		]);
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:navToggle': {
				click: function() {
					scope.toggleMobileNav();
				}
			},
			'ref:mobileLink': {
				click: function() {
					scope.closeMobileNav();
				}
			},
			'ref:mobileNavLink': {
				click: function() {
					scope.closeMobileNav();
				}
			},
			'ref:productsLink': {
				mouseenter: function() {
					var $this = $(this);

					$this.activate();
					scope.enablePopout($this);
					$('ref:popoutNav').attr('aria-hidden', false);
				},
				mouseleave: function() {
					var $this = $(this);

					$this.deactivate();
					scope.disablePopout($this);
					$('ref:popoutNav').attr('aria-hidden', true);
				}
			}

		});
	},

	/**
	 *	Toggle mobile nav
	 *
	 * @private
	 */
	toggleMobileNav: function() {
		this.$mobileMenu.isActive() ?
			this.$mobileMenu.deactivate() :
			this.$mobileMenu.activate();

		$($._body).hasClass('-nav') ? this.disableBody() : this.enableBody();
	},

	disableBody: function() {
		$($._body).removeClass('-nav');
	},

	enableBody: function() {
		$($._body).addClass('-nav');
	},

	/**
	 * Close mobile nav
	 *
	 * @private
	 */
	closeMobileNav: function() {
		this.disableBody();
		this.$mobileMenu.deactivate();
		$('ref:main').css('paddingTop', $('ref:header').height() + 'px');
	},

	/**
	 * Init mobile nav
	 *
	 tel:(800)-485-5872* @private
	 */
	initMobileNav: function() {
		$('ref:header').append(this.$mobileMenu);
	},

	/**
	 * Init desktop nav
	 *
	 * @private
	 */
	initDesktopNav: function() {
		$($._body).enable();
		$('ref:header').append(this.$desktopMenu);
	},

	enablePopout: function(el) {
		var $el = $(el),
			$popoutNav = $('ref:popoutNav');

		$el.children($popoutNav).enable();

		setTimeout(function() {
			$el.children($popoutNav).activate();
		}, 50);
	},

	disablePopout: function(el) {
		var $el = $(el),
			$popoutNav = $('ref:popoutNav');

		$el.children($popoutNav).deactivate();

		setTimeout(function() {
			$el.children($popoutNav).disable();
		}, 200);
	}
});
